export default [
  { id: 1, name: 'Офис' },
  { id: 2, name: 'Розница' },
  { id: 3, name: 'СП' },
  { id: 4, name: 'Магнит Аптеки' },
  { id: 5, name: 'Логистика' },
];
